var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "actions-container" }, [
    _c("button", {
      class: [
        _vm.icons.arrowDown,
        "arrow",
        { disabled: _vm.index + 1 >= _vm.fieldsNumber },
      ],
      on: {
        click: function ($event) {
          $event.stopPropagation()
          _vm.index + 1 >= _vm.fieldsNumber ? false : _vm.moveDown(_vm.index)
        },
      },
    }),
    _c("button", {
      class: [_vm.icons.arrowUp, "arrow", { disabled: _vm.index === 0 }],
      on: {
        click: function ($event) {
          $event.stopPropagation()
          _vm.index === 0 ? false : _vm.moveUp(_vm.index)
        },
      },
    }),
    _c("button", {
      class: [_vm.icons.remove, { disabled: _vm.disableDelete }],
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.removeField(_vm.index)
        },
      },
    }),
    _vm.item.idCustomFieldType !== _vm.numerationCode
      ? _c("button", {
          class: [_vm.icons.configuration],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.editField(_vm.item, _vm.index)
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }